'use strict'
// const custom = require('@/util/custom/debug') // 本地调试
const custom = require('@/util/custom/release') // 线上发布
// const custom = require('@/util/custom/electron-mac') // mac-Electron客户端发布
// const custom = require('@/util/custom/electron-windows') // windows-Electron客户端发布

// 用户信息
export const USER_INFO_UID = 'user_info_uid'
// 收到消息时是否播放声音
export const PLAY_AUDIO = 'playAudio'
// 收到信息时是否显示新消息通知窗口
export const SHOW_NOTIFICATION_WINDOW = 'showNotificationWindow'
// 是否显示底部统计数据
export const SHOW_BOTTOM_STATISTIC = 'showBottomStatistics'
// 是否显示超时提醒
export const SHOW_OUT_OF_TIME = 'showOutOfTime'
// 是否显示输入提示
export const SHOW_INPUT_TIPS = 'showInputTips'
// 是否应该翻译
export const SHOULD_TRANSLATE_INPUT = 'shouldTranslateInput'
// 是否检测是否绑定公众号
export const QUERY_MPQRCODE_URL = 'queryMpQrcodeUrl'
// 是否回车发送消息
export const RETURN_TO_SENDMESSAGE = 'returnToSendMessage'
// 是否显示网络断开恢复提示
export const SHOW_NETWORK_STATUS = 'showNetworkStatus'
// 是否应该推送公众号离线消息
export const SHOULD_WECHAT_MP_PUSH = 'shouldWechatMpPush'
// 国际化设置
export const I18N = 'i18n'
// 登录页面-记住密码
export const SUBDOMAIN = 'subdomain'
export const EMAIL = 'email'
export const PASSWORD = 'password'
// i18n默认语言
export const I18N_DEFAULT_LOCAL = custom.I18N_DEFAULT_LOCAL
// 客服端唯一uuid
export const KICKOFF_UUID = 'kickoff_uuid'
// 是否固定标题, 如果不固定则显示国际化标题，如固定则显示 DEFAULT_TITLE 内容
export const FIX_TITLE = custom.FIX_TITLE
// 默认title
export const DEFAULT_TITLE = custom.DEFAULT_TITLE
// 客户端
export const HTTP_CLIENT = custom.HTTP_CLIENT
// 判断是否为客户端
export const IS_ELECTRON = custom.IS_ELECTRON
// 线上环境
export const IS_PRODUCTION = custom.IS_PRODUCTION
// 是否显示右下角按钮
export const SHOW_BOTTOM_RIGHT_BUTTONS = custom.SHOW_BOTTOM_RIGHT_BUTTONS
// 私有部署验证
export const IS_PRIVATE_SERVER = custom.IS_PRIVATE_SERVER
export const PRIVATE_SERVER_UID = custom.PRIVATE_SERVER_UID
export const PRIVATE_SERVER_VALIDEDATE = custom.PRIVATE_SERVER_VALIDEDATE
// 是否为大学长定制
export const IS_DAXUEZHANG = custom.IS_DAXUEZHANG
export const IS_IP = custom.IS_IP
export const HTTP_PREFIX = custom.HTTP_PREFIX
// 统计数据
// export const SHOW_STATISTIC = custom.SHOW_STATISTIC
// 帮助中心
export const SHOW_SUPPORT = custom.SHOW_SUPPORT
// 意见反馈
export const SHOW_FEEDBACK = custom.SHOW_FEEDBACK
// 管理后台
export const ADMIN_URL = custom.ADMIN_URL
// 登录页面
export const LOGIN_URL = custom.LOGIN_URL
// 单独聊天窗口
export const CHAT_BASE_URL = custom.CHAT_BASE_URL
// 管理后台baseUrl
export const ADMIN_BASE_URL = custom.ADMIN_BASE_URL
// 主页网站
export const HOME_URL = custom.HOME_URL
// 官方帮助首页
export const HELP_URL = custom.HELP_URL
// 续期URL
export const RENEW_URL = 'https://www.weikefu.net/admin/#/antv/pay/recharge'
// 帮助页面base url
// export const HELP_BASE_URL = custom.HELP_BASE_URL
// mq websocket
export const MQ_WEBSOCKET_ENDPOINT = custom.MQ_WEBSOCKET_ENDPOINT
// websocket
export const WEBSOCKET_ENDPOINT = custom.WEBSOCKET_ENDPOINT
// sockjs
export const SOCKJS_WEBSOCKET_ENDPOINT = custom.SOCKJS_WEBSOCKET_ENDPOINT
// 跳转到微信公众号授权页面
export const WECHAT_OPEN_PLATFORM_REDIRECT_URI = custom.WECHAT_OPEN_PLATFORM_REDIRECT_URI
// 私有部署服务器验证url
export const PRIVATE_SERVER_VALIDATE_URL = custom.PRIVATE_SERVER_VALIDATE_URL
// web调试debug/pc/mac客户端调试
export const AXIOS_DEFAULT_BASEURL = custom.AXIOS_DEFAULT_BASEURL
// 是否显示im对话框
export const SHOW_IM = custom.SHOW_IM
// 上传文件3-上传所有类型合体
export const UPLOAD_FILE_URL_V3 = custom.UPLOAD_FILE_URL_V3
// 上传表情
export const UPLOAD_EMOJI_URL = custom.UPLOAD_EMOJI_URL
// 上传图片2
export const UPLOAD_IMAGE_URL_V2 = custom.UPLOAD_IMAGE_URL_V2
// 上传文件2
export const UPLOAD_FILE_URL_V2 = custom.UPLOAD_FILE_URL_V2
// 上传头像
export const UPLOAD_AVATAR_URL = custom.UPLOAD_AVATAR_URL
// 上传图片
export const UPLOAD_IMAGE_URL = custom.UPLOAD_IMAGE_URL
// 上传录音
export const UPLOAD_VOICE_URL = custom.UPLOAD_VOICE_URL
// 上传视频
export const UPLOAD_VIDEO_URL = custom.UPLOAD_VIDEO_URL
// 上传文件
export const UPLOAD_FILE_URL = custom.UPLOAD_FILE_URL
// 上传图片
export const UPLOAD_LAYIM_IMAGE_URL = custom.UPLOAD_LAYIM_IMAGE_URL
// 上传文件
export const UPLOAD_LAYIM_FILE_URL = custom.UPLOAD_LAYIM_FILE_URL
// 上传微信图片
export const UPLOAD_WECHAT_IMAGE_URL = custom.UPLOAD_WECHAT_IMAGE_URL
// 上传微信语音文件
export const UPLOAD_WECHAT_VOICE_URL = custom.UPLOAD_WECHAT_VOICE_URL
// 上传微信视频
export const UPLOAD_WECHAT_VIDEO_URL = custom.UPLOAD_WECHAT_VIDEO_URL
// 上传微信缩略图
export const UPLOAD_WECHAT_THUMB_URL = custom.UPLOAD_WECHAT_THUMB_URL
// 百度ueditor富文本编辑器
export const UEDITOR_SERVER_URL = custom.UEDITOR_SERVER_URL
export const UEDITOR_HOME_URL = custom.UEDITOR_HOME_URL
//
export const MQTT_PORT = custom.MQTT_PORT
export const MQTT_WS_HOST = custom.MQTT_WS_HOST
//
export const MQTT_HOST = custom.MQTT_HOST
// export const MQTT_PROTOBUF_PREFIX = 'protobuf/'
// web、mac 左边导航栏宽度：
export const LEFT_SIDEBAR_WIDTH = '65px'
// 此uid为系统通知用户uid
export const SYSTEM_NOTIFICATION_USER_UUID = '201808221551195'
// stomp连接中
export const STOMP_CONNECTION_STATUS_CONNECTING = 'connecting'
// stomp连接成功
export const STOMP_CONNECTION_STATUS_CONNECTED = 'connected'
// stomp连接断开
export const STOMP_CONNECTION_STATUS_DISCONNECTED = 'disconnncted'
// 网络正常
export const NETWORK_CONNECTION_STATUS_CONNECTED = 'connected'
// 网络断开
export const NETWORK_CONNECTION_STATUS_DISCONNECTED = 'disconnncted'
// 下载页面
export const DOWNLOAD_URL = 'https://www.weikefu.net/pages/download.html'
// 咨询官方客服页面
export const CHAT_URL = 'https://cdn.kefux.com/chat/h5/index.html?sub=vip&uid=201808221551193&wid=201809061716221&type=workGroup&aid=&ph=ph'
// 通知icon图标
export const ICON_URL = 'https://cdn.bytedesk.com/assets/icon/64.png'
// 语音播放器base url
export const VOICE_PLAYER_BASE_URL = 'https://wuxieyun.com/opencore-amr-js/js/index.php?url='
// 声音叮咚
export const SOUND_DINGDONG_URL = 'https://cdn.bytedesk.com/assets/sound/dingdong.wav'
// 表情base url
export const EMOJI_BASE_URL = 'https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/'
// 连接中
export const CONNECTING_IMAGE = 'https://bytedesk.oss-cn-shenzhen.aliyuncs.com/util/connecting.gif'
// 连接成功
export const CONNCTED_IMAGE = 'https://bytedesk.oss-cn-shenzhen.aliyuncs.com/util/connected.png'
// 断开连接
export const DISCONNECTED_IMAGE = 'https://bytedesk.oss-cn-shenzhen.aliyuncs.com/util/disconnected.png'
//
export const DEFAULT_AVATAR = 'https://chainsnow.oss-cn-shenzhen.aliyuncs.com/avatars/agent_default_avatar.png'
//
export const DEFAULT_WORKGROUP_AVATAR = 'https://chainsnow.oss-cn-shenzhen.aliyuncs.com/avatars/workgroup_default_avatar.png'
//
export const DEFAULT_WEB_AVATAR_URL = 'https://chainsnow.oss-cn-shenzhen.aliyuncs.com/avatars/chrome_default_avatar.png'
//
export const DEFAULT_ANDROID_AVATAR_URL = 'https://chainsnow.oss-cn-shenzhen.aliyuncs.com/avatars/android_default_avatar.png'
//
export const DEFAULT_IOS_AVATAR_URL = 'https://chainsnow.oss-cn-shenzhen.aliyuncs.com/avatars/apple_default_avatar.png'
// 管理后台-充值地址
export const RECHARGE_URL = 'https://www.weikefu.net/admin/#/antv/pay/recharge'
// 提示点击续期按钮
export const RECHARGE_HELP_URL = 'https://cdn.bytedesk.com/support/article?sub=vip&uid=201808221551193&aid=202112272055401&ph=ph'

// 上传文件类型
// 上传自定义表情
export const UPLOAD_FILE_TYPE_EMOJI = 'emoji'
// 上传头像
export const UPLOAD_FILE_TYPE_AVATAR = 'avatar'
// 上传图片
export const UPLOAD_FILE_TYPE_IMAGE = 'image'
// 上传语音
export const UPLOAD_FILE_TYPE_VOICE = 'voice'
// 上传视频
export const UPLOAD_FILE_TYPE_VIDEO = 'video'
// 上传文件
export const UPLOAD_FILE_TYPE_FILE = 'file'

// 接收到小程序消息之后Redis publish消息到此
export const WECHAT_MINI_REDIS_CHANNEL = 'wechat_mini_redis_message'
// Socket IO服务器广播小程序排队消息到此
export const WECHAT_MINI_QUEUE_CHANNEL = 'wechat_mini_queue'
// Socket IO服务器广播小程序消息到此
export const WECHAT_MINI_MESSAGE_CHANNEL = 'wechat_mini_message'
// 接收到公众号消息之后Redis publish消息到此
export const WECHAT_MP_REDIS_CHANNEL = 'wechat_mp_redis_message'
// Socket IO服务器广播公众号排队消息到此
export const WECHAT_MP_QUEUE_CHANNEL = 'wechat_mp_queue'
// Socket IO服务器广播公众号消息到此
export const WECHAT_MP_MESSAGE_CHANNEL = 'wechat_mp_message'

// 文本消息类型
export const MESSAGE_TYPE_TEXT = 'text'
// 图片消息类型
export const MESSAGE_TYPE_IMAGE = 'image'
// 文件消息类型
export const MESSAGE_TYPE_FILE = 'file'
// 语音消息类型
export const MESSAGE_TYPE_VOICE = 'voice'
// 视频消息类型
export const MESSAGE_TYPE_VIDEO = 'video'
// 选择消息类型
export const MESSAGE_TYPE_CHOICE = 'choice'
// 表单问卷消息类型
export const MESSAGE_TYPE_SURVEY = 'survey'
// 自定义消息类型
export const MESSAGE_TYPE_CUSTOM = 'custom'
// 红包
export const MESSAGE_TYPE_RED_PACKET = 'red_packet'
// 商品
export const MESSAGE_TYPE_COMMODITY = 'commodity'
// 视频号商品消息
export const MESSAGE_TYPE_CHANNELS_SHOP_PRODUCT = 'channels_shop_product'
// 视频号订单消息
export const MESSAGE_TYPE_CHANNELS_SHOP_ORDER = 'channels_shop_order'
// 短视频消息类型
export const MESSAGE_TYPE_SHORT_VIDEO = 'shortvideo'
// 位置消息类型
export const MESSAGE_TYPE_LOCATION = 'location'
// 卡片消息类型
export const MESSAGE_TYPE_CARD = 'card'
// 链接消息类型
export const MESSAGE_TYPE_LINK = 'link'
// 事件消息类型
export const MESSAGE_TYPE_EVENT = 'event'
// 机器人 自动回复
export const MESSAGE_TYPE_ROBOT = 'robot'
export const MESSAGE_TYPE_ROBOTV2 = 'robotv2'
// 问卷
export const MESSAGE_TYPE_QUESTIONNAIRE = 'questionnaire'
// 分公司，方便提取分公司所包含的国家，金吉列大学长
export const MESSAGE_TYPE_COMPANY = 'company'
// 选择工作组
export const MESSAGE_TYPE_WORK_GROUP = 'workGroup'
// 通知消息类型
export const MESSAGE_TYPE_NOTIFICATION = 'notification'
// 非工作时间
export const MESSAGE_TYPE_NOTIFICATION_NON_WORKING_TIME = 'notification_non_working_time'
// 客服离线，当前无客服在线
export const MESSAGE_TYPE_NOTIFICATION_OFFLINE = 'notification_offline'
// 访客开始网页浏览
export const MESSAGE_TYPE_NOTIFICATION_BROWSE_START = 'notification_browse_start'
// 访客关闭网页
export const MESSAGE_TYPE_NOTIFICATION_BROWSE_END = 'notification_browse_end'
// 邀请访客
export const MESSAGE_TYPE_NOTIFICATION_BROWSE_INVITE = 'notification_browse_invite'
// 访客接受邀请
export const MESSAGE_TYPE_NOTIFICATION_BROWSE_INVITE_ACCEPT = 'notification_browse_invite_accept'
// 访客拒绝邀请
export const MESSAGE_TYPE_NOTIFICATION_BROWSE_INVITE_REJECT = 'notification_browse_invite_reject'
// 新会话thread
export const MESSAGE_TYPE_NOTIFICATION_THREAD = 'notification_thread'
// 重新进入会话
export const MESSAGE_TYPE_NOTIFICATION_THREAD_REENTRY = 'notification_thread_reentry'
// 新建工单
export const MESSAGE_TYPE_NOTIFICATION_TICKET = 'notification_ticket'
// 意见反馈
export const MESSAGE_TYPE_NOTIFICATION_FEEDBACK = 'notification_feedback'
// 留言
export const MESSAGE_TYPE_NOTIFICATION_LEAVEMESSAGE = 'notification_leavemessage'
// 排队通知类型
export const MESSAGE_TYPE_NOTIFICATION_QUEUE = 'notification_queue'
// 排队中离开
export const MESSAGE_TYPE_NOTIFICATION_QUEUE_LEAVE = 'notification_queue_leave'
// 接入队列访客
export const MESSAGE_TYPE_NOTIFICATION_QUEUE_ACCEPT = 'notification_queue_accept'
// 忽略队列访客
export const MESSAGE_TYPE_NOTIFICATION_QUEUE_IGNORE = 'notification_queue_ignore'
// 超时队列访客
export const MESSAGE_TYPE_NOTIFICATION_QUEUE_TIMEOUT = 'notification_queue_timeout'
// 自动接入会话
export const MESSAGE_TYPE_NOTIFICATION_ACCEPT_AUTO = 'notification_accept_auto'
// 手动接入
export const MESSAGE_TYPE_NOTIFICATION_ACCEPT_MANUAL = 'notification_accept_manual'
// 上线
export const MESSAGE_TYPE_NOTIFICATION_CONNECT = 'notification_connect'
// 离线
export const MESSAGE_TYPE_NOTIFICATION_DISCONNECT = 'notification_disconnect'
// 离开会话页面
export const MESSAGE_TYPE_NOTIFICATION_LEAVE = 'notification_leave'
// 客服关闭会话
export const MESSAGE_TYPE_NOTIFICATION_AGENT_CLOSE = 'notification_agent_close'
// 访客关闭会话
export const MESSAGE_TYPE_NOTIFICATION_VISITOR_CLOSE = 'notification_visitor_close'
// 自动关闭会话
export const MESSAGE_TYPE_NOTIFICATION_AUTO_CLOSE = 'notification_auto_close'
// 邀请评价
export const MESSAGE_TYPE_NOTIFICATION_INVITE_RATE = 'notification_invite_rate'
// 评价结果
export const MESSAGE_TYPE_NOTIFICATION_RATE_RESULT = 'notification_rate_result'
// 邀请会话
export const MESSAGE_TYPE_NOTIFICATION_INVITE = 'notification_invite'
// 接受邀请
export const MESSAGE_TYPE_NOTIFICATION_INVITE_ACCEPT = 'notification_invite_accept'
// 拒绝邀请
export const MESSAGE_TYPE_NOTIFICATION_INVITE_REJECT = 'notification_invite_reject'
// 转接会话
export const MESSAGE_TYPE_NOTIFICATION_TRANSFER = 'notification_transfer'
// 接受转接
export const MESSAGE_TYPE_NOTIFICATION_TRANSFER_ACCEPT = 'notification_transfer_accept'
// 拒绝转接
export const MESSAGE_TYPE_NOTIFICATION_TRANSFER_REJECT = 'notification_transfer_reject'
// 满意度请求
export const MESSAGE_TYPE_NOTIFICATION_RATE_REQUEST = 'notification_rate_request'
// 评价
export const MESSAGE_TYPE_NOTIFICATION_RATE = 'notification_rate'
// 连接状态
export const MESSAGE_TYPE_NOTIFICATION_CONNECTION_STATUS = 'notification_connection_status'
// 接待状态
export const MESSAGE_TYPE_NOTIFICATION_ACCEPT_STATUS = 'notification_accept_status'
// 消息预知
export const MESSAGE_TYPE_NOTIFICATION_PREVIEW = 'notification_preview'
// 消息撤回
export const MESSAGE_TYPE_NOTIFICATION_RECALL = 'notification_recall'
// 消息被拒绝
export const MESSAGE_TYPE_NOTIFICATION_BLOCK = 'notification_block'
// 浏览
export const MESSAGE_TYPE_NOTIFICATION_BROWSE = 'notification_browse'
// 非会话类消息通知
export const MESSAGE_TYPE_NOTIFICATION_NOTICE = 'notification_notice'
// 频道通知
export const MESSAGE_TYPE_NOTIFICATION_CHANNEL = 'notification_channel'
// 消息回执
export const MESSAGE_TYPE_NOTIFICATION_RECEIPT = 'notification_receipt'
// 踢掉其他客户端
export const MESSAGE_TYPE_NOTIFICATION_KICKOFF = 'notification_kickoff'
// 窗口抖动提醒
export const MESSAGE_TYPE_NOTIFICATION_SHAKE = 'notification_shake'
// 发送表单请求
// export const MESSAGE_TYPE_NOTIFICATION_FORM = 'notification_form'
// 表单内嵌类型
export const MESSAGE_TYPE_NOTIFICATION_FORM_REQUEST = 'notification_form_request'
export const MESSAGE_TYPE_NOTIFICATION_FORM_RESULT = 'notification_form_result'
// 通知初始化localStream
// export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_INVITE = 'notification_webrtc_invite'
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_INVITE_VIDEO = 'notification_webrtc_invite_video'
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_INVITE_AUDIO = 'notification_webrtc_invite_audio'
// webrtc取消邀请
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_CANCEL = 'notification_webrtc_cancel'
// webrtc邀请视频会话
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_OFFER_VIDEO = 'notification_webrtc_offer_video'
// webrtc邀请音频会话
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_OFFER_AUDIO = 'notification_webrtc_offer_audio'
// 接受webrtc邀请
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_ANSWER = 'notification_webrtc_answer'
// webrtccandidate信息
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_CANDIDATE = 'notification_webrtc_candidate'
// 接受webrtc邀请
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_ACCEPT = 'notification_webrtc_accept'
// 拒绝webrtc邀请
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_REJECT = 'notification_webrtc_reject'
// 被邀请方视频设备 + peeConnection已经就绪
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_READY = 'notification_webrtc_ready'
// webrtc忙线
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_BUSY = 'notification_webrtc_busy'
// 结束webrtc会话
export const MESSAGE_TYPE_NOTIFICATION_WEBRTC_CLOSE = 'notification_webrtc_close'
// 创建群组
export const MESSAGE_TYPE_NOTIFICATION_GROUP_CREATE = 'notification_group_create'
// 更新群名称、简介等
export const MESSAGE_TYPE_NOTIFICATION_GROUP_UPDATE = 'notification_group_update'
// 群公告
export const MESSAGE_TYPE_NOTIFICATION_GROUP_ANNOUNCEMENT = 'notification_group_announcement'
// 邀请多人加入群
export const MESSAGE_TYPE_NOTIFICATION_GROUP_INVITE = 'notification_group_invite'
// 受邀请：同意
export const MESSAGE_TYPE_NOTIFICATION_GROUP_INVITE_ACCEPT = 'notification_group_invite_accept'
// 受邀请：拒绝
export const MESSAGE_TYPE_NOTIFICATION_GROUP_INVITE_REJECT = 'notification_group_invite_reject'
// 不需要审核加入群组
export const MESSAGE_TYPE_NOTIFICATION_GROUP_JOIN = 'notification_group_join'
// 主动申请加入群组
export const MESSAGE_TYPE_NOTIFICATION_GROUP_APPLY = 'notification_group_apply'
// 同意：主动申请加群
export const MESSAGE_TYPE_NOTIFICATION_GROUP_APPLY_APPROVE = 'notification_group_apply_approve'
// 拒绝：主动申请加群
export const MESSAGE_TYPE_NOTIFICATION_GROUP_APPLY_DENY = 'notification_group_apply_deny'
// 踢人
export const MESSAGE_TYPE_NOTIFICATION_GROUP_KICK = 'notification_group_kick'
// 禁言
export const MESSAGE_TYPE_NOTIFICATION_GROUP_MUTE = 'notification_group_mute'
// 移交群组
export const MESSAGE_TYPE_NOTIFICATION_GROUP_TRANSFER = 'notification_group_transfer'
// 移交群组：同意、接受
export const MESSAGE_TYPE_NOTIFICATION_GROUP_TRANSFER_ACCEPT = 'notification_group_transfer_accept'
// 移交群组：拒绝
export const MESSAGE_TYPE_NOTIFICATION_GROUP_TRANSFER_REJECT = 'notification_group_transfer_reject'
// 退出群组
export const MESSAGE_TYPE_NOTIFICATION_GROUP_WITHDRAW = 'notification_group_withdraw'
// 解散群组
export const MESSAGE_TYPE_NOTIFICATION_GROUP_DISMISS = 'notification_group_dismiss'
// 普通通知
export const NOTICE_TYPE_NORMAL = 'normal'
// 工单相关通知
export const NOTICE_TYPE_TICKET = 'ticket';
// 待办任务
export const NOTICE_TYPE_TODO = 'todo';
//
// 会话类型 = 工作组会话、访客跟客服一对一、同事一对一、群组会话
export const THREAD_TYPE_THREAD = 'thread'
// 工作组会话
export const THREAD_TYPE_WORKGROUP = 'workgroup'
// 指定客服会话
export const THREAD_TYPE_APPOINTED = 'appointed'
// 机器人会话
export const THREAD_TYPE_ROBOT = 'robot'
// 同事会话
export const THREAD_TYPE_CONTACT = 'contact'
// 群组会话
export const THREAD_TYPE_GROUP = 'group'
//
export const THREAD_TYPE_LEAVEMSG = 'leavemsg'
export const THREAD_TYPE_FEEDBACK = 'feedback'
//
export const THREAD_TYPE_CHANNEL = 'channel'
// 机器人转人工
export const THREAD_TYPE_ROBOT_TO_AGENT = 'robot_to_agent'
// 工单
export const THREAD_TYPE_TICKET_WORKGROUP = 'ticket_workgroup'
export const THREAD_TYPE_TICKET_APPOINTED = 'ticket_appointed'
// 消息会话类型：访客会话、同事一对一、群组会话
export const MESSAGE_SESSION_TYPE_THREAD = 'thread'
//
export const MESSAGE_SESSION_TYPE_CONTACT = 'contact'
//
export const MESSAGE_SESSION_TYPE_GROUP = 'group'

// 群组相关: 普通群组、讨论组
export const GROUP_TYPE_GROUP = 'group'
export const GROUP_TYPE_DISCUSS = 'discuss'

// 访客消息来源端
// 访客pc网站
export const CLIENT_WEB = 'web'
// 访客手机网站
export const CLIENT_WAP = 'wap'
// 微信商城
export const CLIENT_WEIXIN = 'weixin'
// 网站漂浮框
export const CLIENT_FLOAT = 'float'
// 访客安卓
export const CLIENT_ANDROID = 'android'
// 访客苹果
export const CLIENT_IOS = 'ios'
// Flutter客户端
export const CLIENT_FLUTTER = 'flutter'
//
export const CLIENT_FLUTTER_ANDROID = 'flutter_android'
export const CLIENT_FLUTTER_IOS = 'flutter_ios'
export const CLIENT_FLUTTER_WEB = 'flutter_web'
//
export const CLIENT_FLUTTER_ANDROID_SCHOOL = 'flutter_android_school'
export const CLIENT_FLUTTER_IOS_SCHOOL = 'flutter_ios_school'
export const CLIENT_FLUTTER_WEB_SCHOOL = 'flutter_web_school'
// 访客微信客服接口
export const CLIENT_WECHAT_MP = 'wechat_mp'
// 访客微信自定义菜单
export const CLIENT_WECHAT_URL = 'wechat_url'
// 微信小程序
export const CLIENT_WECHAT_MINI = 'wechat_mini'

// 客服端
// Windwow客服端
export const CLIENT_WINDOW_ADMIN = 'window_admin'
// MAC客服端
export const CLIENT_MAC_ADMIN = 'mac_admin'
// 安卓手机客服端
export const CLIENT_ANDROID_ADMIN = 'android_admin'
// 苹果手机客服端
export const CLIENT_IOS_ADMIN = 'ios_admin'
// web客服端
export const CLIENT_WEB_ADMIN = 'web_admin'
// 微信小程序客服端
export const CLIENT_WECHAT_MINI_ADMIN = 'wechat_mini_admin'
// 系统端
export const CLIENT_SYSTEM = 'system'
//
export const CLIENT_WEB_MQTT = 'web_mqtt'

// 消息发送状态
// 发送中
export const MESSAGE_STATUS_SENDING = 'sending'
// 送达
export const MESSAGE_STATUS_RECEIVED = 'received'
// 已读
export const MESSAGE_STATUS_READ = 'read'
// 发送到服务器，成功存储数据库中
export const MESSAGE_STATUS_STORED = 'stored'
// 发送错误
export const MESSAGE_STATUS_ERROR = 'error'
// 阅后即焚已销毁
export const MESSAGE_STATUS_DESTROYED = 'destroyed'
// 消息撤回
export const MESSAGE_STATUS_RECALL = 'recall'
// 对方拒收
export const MESSAGE_STATUS_REJECT = 'reject'

// 客服在线状态
// 跟服务器建立长连接
export const USER_STATUS_CONNECTED = 'connected'
// 断开长连接
export const USER_STATUS_DISCONNECTED = 'disconnected'
// 在线状态
export const USER_STATUS_ONLINE = 'online'
// 离线状态
export const USER_STATUS_OFFLINE = 'offline'
// 忙
export const USER_STATUS_BUSY = 'busy'
// 离开
export const USER_STATUS_AWAY = 'away'
// 登出
export const USER_STATUS_LOGOUT = 'logout'
// 登录
export const USER_STATUS_LOGIN = 'login'
// 离开
export const USER_STATUS_LEAVE = 'leave'
// 话后
export const USER_STATUS_AFTER = 'after'
// 就餐
export const USER_STATUS_EAT = 'eat'
// 小休
export const USER_STATUS_REST = 'rest'

// 工单状态(客服角度): 待认领、待回复、处理中、已解决、已忽略
export const TICKET_STATUS_UNCLAIM = 'unclaim'
export const TICKET_STATUS_TO_BE_REPLIED = 'to_be_replied'
export const TICKET_STATUS_PROCESSING = 'processing'
export const TICKET_STATUS_DONE = 'done'
export const TICKET_STATUS_IGNORE = 'ignore'

// 角色类型
// 超级管理员
export const ROLE_SUPER = 'ROLE_SUPER'
// 注册管理员：注册用户默认角色
export const ROLE_ADMIN = 'ROLE_ADMIN'
// 付费注册用户
export const ROLE_VIP = 'ROLE_VIP'
// 试用会员
export const ROLE_TRY = 'ROLE_TRY'
// 第三方代理公司
export const ROLE_PROXY = 'ROLE_PROXY'
// 免费注册用户
export const ROLE_FREE = 'ROLE_FREE'
// 访客
export const ROLE_VISITOR = 'ROLE_VISITOR'
// 普通员工：非客服人员
export const ROLE_MEMBER = 'ROLE_MEMBER'
// 智能客服：客服机器人
export const ROLE_ROBOT = 'ROLE_ROBOT'
// 客服组长，工作组管理员
export const ROLE_WORKGROUP_ADMIN = 'ROLE_WORKGROUP_ADMIN'
// 接待访客角色，如果要接待访客，必须赋予此角色
export const ROLE_WORKGROUP_AGENT = 'ROLE_WORKGROUP_AGENT'
// 质检账号
export const ROLE_WORKGROUP_CHECKER = 'ROLE_WORKGROUP_CHECKER'
// 自动回复
export const AUTO_REPLY_NO = '无自动回复'
//
export const AUTO_REPLY_EAT = '外出就餐，请稍后'
//
export const AUTO_REPLY_LEAVE = '不在电脑旁，请稍后'
//
export const AUTO_REPLY_BACK = '马上回来'
//
export const AUTO_REPLY_PHONE = '接听电话中'
//
export const AUTO_REPLY_SELF = '自定义'
// 权限
// 我的首页
export const AUTHORITY_HOME = 'home'
// 绩效数据
export const AUTHORITY_STATISTIC = 'statistic'
// 人工客服
export const AUTHORITY_CHAT = 'chat'
// 人工客服-当前会话
export const AUTHORITY_THREAD = 'thread'
// 人工客服-当前访客
export const AUTHORITY_VISITOR = 'visitor'
// 人工客服-历史记录
export const AUTHORITY_HISTORY = 'history'
// 人工客服-监控组内所有会话
export const AUTHORITY_MONITOR = 'monitor'
// 人工客服-Quality Assurance(QA) 质量检查
export const AUTHORITY_QUALITY = 'quality'
// 人工客服-客服账号CRUD增删改查
export const AUTHORITY_ADMIN = 'admin'
// 智能客服
export const AUTHORITY_ROBOT = 'robot'
// 帮助中心
export const AUTHORITY_SUPPORT = 'support'
// 所有设置
export const AUTHORITY_SETTING = 'setting'
// 意见反馈
export const AUTHORITY_FEEDBACK = 'feedback'
// 工单系统
export const AUTHORITY_WORKORDER = 'workorder'
// 呼叫中心
export const AUTHORITY_CALLCENTER = 'callcenter'
// 客户管理
export const AUTHORITY_CRM = 'crm'
// 调查问卷
export const AUTHORITY_WENJUAN = 'wenjuan'
// 内部协同
export const AUTHORITY_INTERNAL = 'internal'

// 通知账号
export const USERNAME_NOTIFICATION = 'bytedesk_notification'

// 快捷回复类型
// 快捷回复 = 平台类型
// CUW_TYPE_PLATFORM = 'platform'
// 快捷回复 = 公司类型
export const CUW_TYPE_COMPANY = 'company'
// 快捷回复 = 客服类型
export const CUW_TYPE_MINE = 'mine'

// 类别类型：智能客服robot
export const CATEGORY_TYPE_ROBOT = 'robot'
// 帮助文档support
export const CATEGORY_TYPE_SUPPORT = 'support'
// 快捷回复分类：cuw
export const CATEGORY_TYPE_CUW_MINE = 'cuw_mine'
export const CATEGORY_TYPE_CUW_COMPANY = 'cuw_company'
export const CATEGORY_TYPE_CUW_PLATFORM = 'cuw_platform'

// 问卷题目类型：单选、多选，单行输入input、多行输入textarea
export const QUESTIONNAIRE_ITEM_TYPE_RADIO = 'radio'
export const QUESTIONNAIRE_ITEM_TYPE_CHECKBOX = 'checkbox'
export const QUESTIONNAIRE_ITEM_TYPE_INPUT = 'input'
export const QUESTIONNAIRE_ITEM_TYPE_TEXTAREA = 'textarea'

// 收到新消息
export const EVENT_BUS_NEW_MESSAGE = 'EVENT_BUS_NEW_MESSAGE'
// 查看历史消息记录
export const EVENT_BUS_MESSAGE_HISTORY = 'EVENT_BUS_MESSAGE_HISTORY'
// 选中快捷回复
export const EVENT_BUS_SELECT_CUW = 'EVENT_BUS_SELECT_CUW'
// 发送快捷回复
export const EVENT_BUS_SEND_CUW = 'EVENT_BUS_SEND_CUW'
// 将消息添加到快捷回复
export const EVENT_BUS_ADD_MESSAGE_TO_CUW = 'EVENT_BUS_ADD_MESSAGE_TO_CUW'
// 选中某条会话
export const EVENT_BUS_SELECT_THREAD = 'EVENT_BUS_SELECT_THREAD'
// 通知成功
export const EVENT_BUS_NOTIFICATION_SUCCESS = 'EVENT_BUS_NOTIFICATION_SUCCESS'
// 通知警告
export const EVENT_BUS_NOTIFICATION_WARNING = 'EVENT_BUS_NOTIFICATION_WARNING'
// 通知信息
export const EVENT_BUS_NOTIFICATION_INFO = 'EVENT_BUS_NOTIFICATION_INFO'
// 通知报错
export const EVENT_BUS_NOTIFICATION_ERROR = 'EVENT_BUS_NOTIFICATION_ERROR'
// 联系人消息
export const EVENT_BUS_NOTIFICATION_CONTACT_MESSAGE = 'EVENT_BUS_NOTIFICATION_CONTACT_MESSAGE'
// 群组消息
export const EVENT_BUS_NOTIFICATION_GROUP_MESSAGE = 'EVENT_BUS_NOTIFICATION_GROUP_MESSAGE'
// 邀请会话请求
export const EVENT_BUS_NOTIFICATION_INVITE = 'EVENT_BUS_NOTIFICATION_INVITE'
// 访客开始网页浏览
export const EVENT_BUS_NOTIFICATION_BROWSE_START = 'EVENT_BUS_NOTIFICATION_BROWSE_START'
// 访客关闭网页
export const EVENT_BUS_NOTIFICATION_BROWSE_END = 'EVENT_BUS_NOTIFICATION_BROWSE_END'
// 接受邀请会话请求
export const EVENT_BUS_NOTIFICATION_INVITE_ACCEPT = 'EVENT_BUS_NOTIFICATION_INVITE_ACCEPT'
// 拒绝邀请会话请求
export const EVENT_BUS_NOTIFICATION_INVITE_REJECT = 'EVENT_BUS_NOTIFICATION_INVITE_REJECT'
// 转接会话请求
export const EVENT_BUS_NOTIFICATION_TRANSFER = 'EVENT_BUS_NOTIFICATION_TRANSFER'
// 转接会话请求发送成功
export const EVENT_BUS_NOTIFICATION_TRANSFER_SENDOK = 'EVENT_BUS_NOTIFICATION_TRANSFER_SENDOK'
// 转接会话请求被接受
export const EVENT_BUS_NOTIFICATION_TRANSFER_ACCEPT = 'EVENT_BUS_NOTIFICATION_TRANSFER_ACCEPT'
// 转接会话请求被拒绝
export const EVENT_BUS_NOTIFICATION_TRANSFER_REJECT = 'EVENT_BUS_NOTIFICATION_TRANSFER_REJECT'
// 通知界面滚动到底部
export const EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM = 'EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM'
// 聊天记录加载完毕
export const EVENT_BUS_MESSAGE_LOADED = 'EVENT_BUS_MESSAGE_LOADED'
// 群组加载完毕
export const EVENT_BUS_GROUP_LOADED = 'EVENT_BUS_GROUP_LOADED'
// 待办加载完毕
export const EVENT_BUS_TODO_LOADED = 'EVENT_BUS_TODO_LOADED'
// 队列加载完毕
export const EVENT_BUS_QUEUE_LOADED = 'EVENT_BUS_QUEUE_LOADED'
// 黑名单加载完毕
export const EVENT_BUS_BLOCKED_LOADED = 'EVENT_BUS_BLOCKED_LOADED'
// 拉黑用户
export const EVENT_BUS_BLOCK_USER = 'EVENT_BUS_BLOCK_USER'
// 登录超时
export const EVENT_BUS_LOGIN_TIMEOUT = 'EVENT_BUS_LOGIN_TIMEOUT'
// 用户名或密码错误
export const EVENT_BUS_LOGIN_ERROR_400 = 'EVENT_BUS_LOGIN_ERROR_400'
// 服务器错误500
export const EVENT_BUS_SERVER_ERROR_500 = 'EVENT_BUS_SERVER_ERROR_500'
// 创建帮助中心文章
export const EVENT_BUS_SUPPORT_NEW_ARTICLE = 'EVENT_BUS_SUPPORT_NEW_ARTICLE'
// 创建成功
export const EVENT_BUS_SUPPORT_NEW_ARTICLE_SUCCESS = 'EVENT_BUS_SUPPORT_NEW_ARTICLE_SUCCESS'
// 保存错误
export const EVENT_BUS_SUPPORT_NEW_ARTICLE_ERROR = 'EVENT_BUS_SUPPORT_NEW_ARTICLE_ERROR'
// 更新文档
export const EVENT_BUS_SUPPORT_EDIT_ARTICLE = 'EVENT_BUS_SUPPORT_EDIT_ARTICLE'
// 更新成功
export const EVENT_BUS_SUPPORT_UPDATE_ARTICLE_SUCCESS = 'EVENT_BUS_SUPPORT_UPDATE_ARTICLE_SUCCESS'
// 更新错误
export const EVENT_BUS_SUPPORT_UPDATE_ARTICLE_ERROR = 'EVENT_BUS_SUPPORT_UPDATE_ARTICLE_ERROR'
// 创建工单
export const EVENT_BUS_SUPPORT_NEW_TICKET = 'EVENT_BUS_SUPPORT_NEW_TICKET'
// 创建工单成功
export const EVENT_BUS_SUPPORT_NEW_TICKET_SUCCESS = 'EVENT_BUS_SUPPORT_NEW_TICKET_SUCCESS'
// 保存工单错误
export const EVENT_BUS_SUPPORT_NEW_TICKET_ERROR = 'EVENT_BUS_SUPPORT_NEW_TICKET_ERROR'
// 更新工单
export const EVENT_BUS_SUPPORT_EDIT_TICKET = 'EVENT_BUS_SUPPORT_EDIT_TICKET'
// 更新工单成功
export const EVENT_BUS_SUPPORT_UPDATE_TICKET_SUCCESS = 'EVENT_BUS_SUPPORT_UPDATE_TICKET_SUCCESS'
// 更新工单错误
export const EVENT_BUS_SUPPORT_UPDATE_TICKET_ERROR = 'EVENT_BUS_SUPPORT_UPDATE_TICKET_ERROR'
// 查看统计详情
export const EVENT_BUS_STATISTIC_DETAIL = 'EVENT_BUS_STATISTIC_DETAIL'
// 客服、工作组 代码页面
export const EVENT_BUS_AGENT_CODE = 'EVENT_BUS_AGENT_CODE'
export const EVENT_BUS_WORKGROUP_CODE = 'EVENT_BUS_WORKGROUP_CODE'
// 管理公众号
export const EVENT_BUS_MP_ADMIN = 'EVENT_BUS_MP_ADMIN'
//
export const EVENT_BUS_CONTACT_LOAD_FINISHED = 'EVENT_BUS_CONTACT_LOAD_FINISHED'
export const EVENT_BUS_AGENT_LOAD_FINISHED = 'EVENT_BUS_AGENT_LOAD_FINISHED'
export const EVENT_BUS_WORKGROUP_LOAD_FINISHIED = 'EVENT_BUS_WORKGROUP_LOAD_FINISHIED'
export const EVENT_BUS_COMPANY_LOAD_FINISHED = 'EVENT_BUS_COMPANY_LOAD_FINISHED'
// 添加群组
export const EVENT_BUS_GROUP_ADDED = 'EVENT_BUS_GROUP_ADDED'
// 创建问卷
export const EVENT_BUS_NEW_QUESTIONNAIRE = 'EVENT_BUS_NEW_QUESTIONNAIRE'
// 消息预知
export const EVENT_BUS_MESSAGE_PREVIEW = 'EVENT_BUS_MESSAGE_PREVIEW'
// 消息回执
export const EVENT_BUS_MESSAGE_RECEIPT = 'EVENT_BUS_MESSAGE_RECEIPT'
// 消息撤回
export const EVENT_BUS_MESSAGE_RECALL = 'EVENT_BUS_MESSAGE_RECALL'
// 非会话消息，如：会议通知等
export const EVENT_BUS_MESSAGE_NOTICE = 'EVENT_BUS_MESSAGE_NOTICE'
// 通知初始化localStream
export const EVENT_BUS_MESSAGE_WEBRTC_INVITE_VIDEO = 'EVENT_BUS_MESSAGE_WEBRTC_INVITE_VIDEO'
export const EVENT_BUS_MESSAGE_WEBRTC_INVITE_AUDIO = 'EVENT_BUS_MESSAGE_WEBRTC_INVITE_AUDIO'
// webrtc取消邀请
export const EVENT_BUS_MESSAGE_WEBRTC_CANCEL = 'EVENT_BUS_MESSAGE_WEBRTC_CANCEL'
// webrtc邀请视频会话
export const EVENT_BUS_MESSAGE_WEBRTC_OFFER_VIDEO = 'EVENT_BUS_MESSAGE_WEBRTC_OFFER_VIDEO'
// webrtc邀请音频会话
export const EVENT_BUS_MESSAGE_WEBRTC_OFFER_AUDIO = 'EVENT_BUS_MESSAGE_WEBRTC_OFFER_AUDIO'
// 接受webrtc邀请
export const EVENT_BUS_MESSAGE_WEBRTC_ANSWER = 'EVENT_BUS_MESSAGE_WEBRTC_ANSWER'
// webrtccandidate信息
export const EVENT_BUS_MESSAGE_WEBRTC_CANDIDATE = 'EVENT_BUS_MESSAGE_WEBRTC_CANDIDATE'
// 接受webrtc邀请
export const EVENT_BUS_MESSAGE_WEBRTC_ACCEPT = 'EVENT_BUS_MESSAGE_WEBRTC_ACCEPT'
// 本地消息通知
export const EVENT_BUS_WEBRTC_ACCEPT = 'EVENT_BUS_WEBRTC_ACCEPT'
// 拒绝webrtc邀请
export const EVENT_BUS_MESSAGE_WEBRTC_REJECT = 'EVENT_BUS_MESSAGE_WEBRTC_REJECT'
// 被邀请方视频设备 + peeConnection已经就绪
export const EVENT_BUS_MESSAGE_WEBRTC_READY = 'EVENT_BUS_MESSAGE_WEBRTC_READY'
// webrtc忙线
export const EVENT_BUS_MESSAGE_WEBRTC_BUSY = 'EVENT_BUS_MESSAGE_WEBRTC_BUSY'
// 结束webrtc会话
export const EVENT_BUS_MESSAGE_WEBRTC_CLOSE = 'EVENT_BUS_MESSAGE_WEBRTC_CLOSE'
// stomp连接
export const EVENT_BUS_STOMP_CONNECTION_STATUS = 'EVENT_BUS_STOMP_CONNECTION_STATUS'
// 长连接已经断开
export const EVENT_BUS_DISCONNECTED = 'EVENT_BUS_DISCONNECTED'
// 账号到期
export const EVENT_BUS_OUT_OF_SERVICE = 'EVENT_BUS_OUT_OF_SERVICE'
// 续期提醒
export const EVENT_BUS_VALIDATE_DATE = 'EVENT_BUS_VALIDATE_DATE'
// 退出登录，跳转到登录页面
export const EVENT_BUS_LOGOUT = 'EVENT_BUS_LOGOUT'
// 显示crm编辑
export const EVENT_BUS_SHOW_CRM_DRAWER = 'EVENT_BUS_SHOW_CRM_DRAWER'
// 显示ticket编辑
export const EVENT_BUS_SHOW_TICKET_DRAWER = 'EVENT_BUS_SHOW_TICKET_DRAWER'
// 显示转接会话drawer
export const EVENT_BUS_SHOW_TRANSFER_DRAWER = 'EVENT_BUS_SHOW_TRANSFER_DRAWER'
// 显示小结drawer
export const EVENT_BUS_SHOW_SUMMARY_DRAWER = 'EVENT_BUS_SHOW_SUMMARY_DRAWER'
// 显示标签dialog
export const EVENT_BUS_SHOW_TAG_DIALOG = 'EVENT_BUS_SHOW_TAG_DIALOG'
// 显示结束会话dialog
export const EVENT_BUS_SHOW_CLOSE_CHAT = 'EVENT_BUS_SHOW_CLOSE_CHAT'
// 创建通知
export const EVENT_BUS_CREATE_NOTICE = 'EVENT_BUS_CREATE_NOTICE'
// 创建待办任务
export const EVENT_BUS_CREATE_TODO = 'EVENT_BUS_CREATE_TODO'
// 编辑更新待办任务
export const EVENT_BUS_UPDATE_TODO = 'EVENT_BUS_UPDATE_TODO'
// 删除待办任务
export const EVENT_BUS_DELETE_TODO = 'EVENT_BUS_DELETE_TODO'
// 添加到crm
export const EVENT_BUS_THREAD_ADD_CRM = 'EVENT_BUS_THREAD_ADD_CRM'
// 创建工单
export const EVENT_BUS_THREAD_ADD_TICKET = 'EVENT_BUS_THREAD_ADD_TICKET'
// 转接会话
export const EVENT_BUS_THREAD_ADD_TRANSFER = 'EVENT_BUS_THREAD_ADD_TRANSFER'
// 邀请客服加入会话
export const EVENT_BUS_THREAD_ADD_INVITE = 'EVENT_BUS_THREAD_ADD_INVITE'
// 会话小结
export const EVENT_BUS_THREAD_ADD_SUMMARY = 'EVENT_BUS_THREAD_ADD_SUMMARY'
// 客服关闭会话
export const EVENT_BUS_THREAD_AGENT_CLOSE = 'EVENT_BUS_THREAD_AGENT_CLOSE'
// 显示自定义表情
export const EVENT_BUS_SHOW_EMOTION_POPOVER = 'EVENT_BUS_SHOW_EMOTION_POPOVER'
// 显示自定义图片
export const EVENT_BUS_SHOW_IMAGES_POPOVER = 'EVENT_BUS_SHOW_IMAGES_POPOVER'
// 显示自定义文件
export const EVENT_BUS_SHOW_FILES_POPOVER = 'EVENT_BUS_SHOW_FILES_POPOVER'
// access_token
export const ACCESS_TOKEN = 'Access-Token'
